
import gallery1 from "landing-page-mn/assets/imgs/CarouselImages/gallery1.png";
import gallery2 from "landing-page-mn/assets/imgs/CarouselImages/gallery2.png";
import gallery3 from "landing-page-mn/assets/imgs/CarouselImages/gallery3.png";
import gallery4 from "landing-page-mn/assets/imgs/CarouselImages/gallery4.png";
import gallery5 from "landing-page-mn/assets/imgs/CarouselImages/gallery5.png";
import gallery6 from "landing-page-mn/assets/imgs/CarouselImages/gallery6.png";
import gallery7 from "landing-page-mn/assets/imgs/CarouselImages/gallery7.png";
import gallery8 from "landing-page-mn/assets/imgs/CarouselImages/gallery8.png";
import gallery9 from "landing-page-mn/assets/imgs/CarouselImages/gallery9.png";

export const Imasgelist = [gallery1,
                           gallery2,
                           gallery3,
                           gallery4,
                           gallery5,
                           gallery6,
                           gallery7,
                           gallery8,
                           gallery9];
